var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPeriodicalsSpecialty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#333;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M67.06272,37.16759H27.99998v35.45789h44V37.16759h-4.93726Zm-2.07227,4.0293v11.68506h-29.9809v-11.68506h29.9809Zm-29.9809,27.39929v-11.685h8.33716l1.40051,1.87354c1.18146,1.58044,3.03912,2.51111,5.01233,2.51111h.53625c1.97327,0,3.83087-.93066,5.01233-2.51111l1.40051-1.87354h8.2818v11.685h-29.9809Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M58.0557,30.25426c-1.35492-1.8125-3.48529-2.87976-5.74823-2.87976h-4.61499c-2.26288,0-4.39331,1.06726-5.74817,2.87976l-1.60614,2.14856h19.32367l-1.60614-2.14856Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPeriodicalsSpecialty);
export default __webpack_public_path__ + "static/media/icon_periodicals_specialty.00b289aa15862984e6e904c813ec686b.svg";
export { ForwardRef as ReactComponent };